/**
 * Navbar / UI logo: place the asset at `public/images/cloudaxe_onlyLogo_Transparent_NoBuffer.png`
 * (served under Next `basePath`).
 */
export const CLOUDAXE_LOGO_URL = `${process.env.NEXT_PUBLIC_BASE_PATH ?? ''}/images/cloudaxe_onlyLogo_Transparent_NoBuffer.png`
